import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * PublicLayout - Layout wrapper for public pages (landing, auth, onboarding, checkout)
 *
 * Forces the original dark navy/cyan theme for all pre-dashboard pages,
 * regardless of what the user has toggled in the dashboard.
 */
export default function PublicLayout() {
  useEffect(() => {
    // Restore saved theme preference for public pages (light by default)
    const saved = localStorage.getItem('pulse-theme');
    if (saved === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
      document.documentElement.classList.remove('dark');
    }

    return () => {
      // When navigating into the dashboard, restore the user's saved preference
      const savedOnLeave = localStorage.getItem('pulse-theme');
      if (savedOnLeave === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark');
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.removeAttribute('data-theme');
        document.documentElement.classList.remove('dark');
      }
    };
  }, []);

  return <Outlet />;
}
